module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "sea-ice--discovery-cover.769454dc.jpg";